
































































import Vue, { PropType } from 'vue';
import { Pagination } from '@/api/interfaces/common/pagination';
import FormInputText from '@/components/atoms/formInputText/FormInputText.vue';
import AppPagination from '@/components/molecules/appPagination/AppPagination.vue';
import { AdminUpdateDataModel } from '@/types/app/admin/adminUpdateDataModel';
import { AdminPaginationContent } from '@/api/interfaces/content/app/adminPaginationContent';
import DatePicker from '@/components/molecules/datePicker/DatePicker.vue';
import FormDropdownCheckboxList from '@/components/molecules/formDropdownCheckboxList/FormDropdownCheckboxList.vue';
import { DateRangeField } from '@/types/forms/fields/dateRangeField';
import { CheckboxesField } from '@/types/forms/fields/checkboxesField';
import {
    EntryListContent,
    EntryListContentFinalLayer,
} from '@/api/interfaces/content/common/entryListContent';
import { FormOption } from '@/types/forms/formOption';
import { CheckboxListContent } from '@/api/interfaces/content/form/base/checkboxListContent';
import { PlaceholderContent } from '@/api/interfaces/content/form/base/placeholderContent';
import AppButton from '@/components/atoms/appButton/AppButton.vue';
import { CheckboxField } from '@/types/forms/fields/checkboxField';
import FormField from '@/components/molecules/formField/FormField.vue';
import FormBooleanCheckbox from '@/components/molecules/formBooleanCheckbox/FormBooleanCheckbox.vue';
import moment from 'moment';

export default Vue.extend({
    name: 'AdminPagination',
    components: {
        FormInputText,
        AppPagination,
        DatePicker,
        FormDropdownCheckboxList,
        AppButton,
        FormField,
        FormBooleanCheckbox,
    },
    props: {
        content: {
            type: Object as PropType<AdminPaginationContent>,
            required: true,
        },
        pagination: {
            type: Object as PropType<Pagination>,
            required: true,
        },
        nextApiDispatchAt: {
            type: String,
            default: null,
        },
        adminUpdateData: {
            type: Object as PropType<AdminUpdateDataModel>,
            default: new AdminUpdateDataModel(),
        },
        enumsContent: {
            type: Object as PropType<EntryListContent>,
            required: true,
        },
        applicationStatusItems: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            queryModel: {
                value: this.adminUpdateData.query,
            },
            filterDateSentAtModel: new DateRangeField({
                value: {
                    start: this.adminUpdateData.dateSentAtStart,
                    end: this.adminUpdateData.dateSentAtEnd,
                },
            }),
            filterStatusModel: new CheckboxesField({
                value: this.adminUpdateData.statuses,
                options: [],
            }),
            filterStatusContent: {
                options: {},
                ...this.content.filterStatus,
            } as CheckboxListContent & PlaceholderContent,
            filterApiProblemsModel: new CheckboxField({
                value: this.adminUpdateData.apiProblemsOnly,
            }),
        };
    },
    computed: {
        page(): number {
            const page =
                1 + Math.floor(this.pagination.offset / this.pagination.limit);
            return isNaN(page) ? 1 : page;
        },
        texts(): { first: string; last: string; count: string } {
            return {
                first: this.content.paginationTextFirst,
                last: this.content.paginationTextLast,
                count: this.content.paginationTextCount,
            };
        },
    },
    watch: {
        'queryModel.value'() {
            this.$emit('query-changed', this.queryModel.value);
        },
        'filterDateSentAtModel.value': {
            handler(): void {
                this.$emit(
                    'date-sent-at-changed',
                    this.filterDateSentAtModel.value,
                );
            },
            deep: true,
        },
        'filterStatusModel.value': {
            handler(): void {
                this.$emit('statuses-changed', this.filterStatusModel.value);
            },
            deep: true,
        },
        'filterApiProblemsModel.value'() {
            this.$emit(
                'api-problems-changed',
                this.filterApiProblemsModel.value || false,
            );
        },
    },
    created(): void {
        const statusSource = this.applicationStatusItems ?? {};
        for (const key of Object.keys(statusSource)) {
            this.filterStatusModel.options.push(new FormOption({ key: key }));
            this.filterStatusContent.options[key] = {
                label: statusSource[key]?.label ?? key,
            };
        }
    },
    methods: {
        handlePageChanged(page: number): void {
            this.$emit('page-changed', page);
        },
        handleFilterResetClicked(): void {
            this.queryModel.value = '';
            this.filterDateSentAtModel.value = { start: '', end: '' };
            this.filterStatusModel.value = [];
            this.filterApiProblemsModel.value = false;
            this.$emit('filter-reset');
        },
        formatNextApiDispatchAt(nextApiDispatchAt: string): string {
            return moment(nextApiDispatchAt).format('HH:mm');
        },
    },
});
